VP = window.VP || {};
VP_mapModule_data = window.VP_mapModule_data || {};

(function( $ ) {
	VP.exploreNeighborhoodModule = {
		/*
		 * Google API Key.
		 * Can get one from https://developers.google.com/maps/documentation/geocoding/start
		 */
		APIKey: VP_global.gmaps_key,
		landmark_data: VP_mapModule_data.poi,
		region_data: VP_mapModule_data.region,

		mapStyle: null,
		geocoder: null,
		map: null,
		bounds: null, // contains the bounds for all locations
		detailBounds: null,
		leftMostLocation: null,
		processedLocations: 0,
		spacer: null,
		circles: [],
		subCircles: [],
		subregion_circles: [],
		subregion_subCircles: [],
		markers: [],
		subregion_markers: [],
		landmark_markers: [],
		active: false,
		areas: [],
		longitude: null,
		latitude: null,
		latMax: null,
		latMin: null,
		lngMax: null,
		lngMin: null,
		defaultZoom: null,
		secondaryZoom: null,
		maxZoom: null,
		minZoom: null,
		landmark_legend: $('.vp-explore__landmarks'),
		landmark_legendItem: $('.vp-explore__landmarks-item'),
		canRedraw: true,
		neighborhood: null,
		currentRegion: null,
		regionSelect: $('#vp-explore__select-area'),
		neighborhoodSelect: $('#vp-explore__select-neighborhood'),
		mapElement: $('#vp-explore__map'),
		mapContainerElement: $('.vp-explore__map-container'),
		mapOverlay: $('.vp-explore__map-overlay'),
		neighborhoodImgContainerSmall: $('.vp-explore__map-image-container'),
		landmarkArrow: {
			north: $('.vp-explore__landmarks-direction-bubble-north'),
			east: $('.vp-explore__landmarks-direction-bubble-east'),
			south: $('.vp-explore__landmarks-direction-bubble-south'),
			west: $('.vp-explore__landmarks-direction-bubble-west')
		},
		swipeable: true,

		init: function () {
			var _this = this;

			// Initialize module only if it exists in the DOM
			if ( ! $('.vp-explore').length ) {
				return;
			}

			//check if map container element exist on the page
			if (_this.mapElement.length) {
				// Set the initial region before loading the map
				if (_this.region_data) {
					_this.region_data.forEach(function(obj,i) {
							if (obj.active) {
								_this.currentRegion = obj;
							}
					});
				}

				// If there are no Neighborhodod region data, display error message, then exit out of initializing the map.
				if (_this.currentRegion) {
					_this.setRegionSettings(_this.currentRegion.name);
				} else {
					console.error("There are no region data for the Explore Neighborhoods map");
					return;
				}

				/* We can not have two maps being loaded async
				 * So if Location reference map is in the page it creates
				 * a class when it is done loading.
				 * Explore neighborhood map listens for that class to be added before it loads.
				 * This is a workaround since IE 11 does not support custom events.
				 */
				var locationReferenceMap = document.getElementById('vp-location-reference__map');
				if (locationReferenceMap) {
					var checkLocationMapLoadStatus = setInterval(function() {
						if ( locationReferenceMap.classList.contains('vp-location-reference__map--loaded') ) {
							_this.loadMapStyle();
							clearInterval(checkLocationMapLoadStatus);
						}
					}, 250 );
				} else {
					_this.loadMapStyle();
				}

			}
		},

		loadMapStyle: function() {
			var _this = this;
			/*
			 * Get map styling from /wp-content/themes/visitphilly/lib/google-map-style.json
			 * JSON generated from https://mapstyle.withgoogle.com/
			 */
			var jqxhr = $.getJSON( "/wp-content/themes/visitphilly/lib/google-map-style.json")
				.done(function() {
					_this.mapStyle = jqxhr.responseJSON;

					// Check if google api is already loaded
					if (typeof google === 'object' && typeof google.maps === 'object') {
						_this.initMap();
					} else {
						VP.helpers.loadScript('https://maps.googleapis.com/maps/api/js?key=' + _this.APIKey + '&callback=VP.exploreNeighborhoodModule.initMap');
					}
				})
				.fail(function() {
					throw Error("Unable to load map style");
				});
			_this.eventHandler();

		},

		eventHandler: function() {
			var _this = this;
			/*
			 * Click on the detail close (X) btn closes Neighborhood detail view
			 */
			$('.vp-explore__area').on('click', '.vp-area__close', function(e) {
				e.preventDefault();
				_this.closeAreaDetail(true);
			});

			_this.regionSelect.change(function() {
				_this.resetRegion( this.options[this.selectedIndex].getAttribute('data-name') );
				_this.drawLandmarksDirection();
			});

			_this.neighborhoodSelect.change(function() {
				var selectValue = this.options[this.selectedIndex].getAttribute('value');

				if (selectValue) {
					_this.viewArea( _this.circles[selectValue] );
				}
			});

			//re-center map. Button only appears after user has panned the map
			$('#vp-explore__reset-btn').on('click', function(e) {
				e.preventDefault();
				_this.reCenterMap();
			});

			// center the map on the Point of Interest when legend link is clicked
			_this.landmark_legendItem.on('click', function(e) {
				e.preventDefault();
				_this.gotoLandmark(e);
			});

			// arrow to select map or image of neighborhood on small viewport
			$('.vp-area-arrow-next').on('click', function(e) {
				e.preventDefault();
				_this.shiftMapImage('left', e);
			});

			$('.vp-area-arrow-prev').on('click', function(e) {
				e.preventDefault();
				_this.shiftMapImage('right', e);
			});

			this.mobileDetailSwipeable();
			this.bindEscClose();
		},

		initMap: function() {
			var _this = this;

			// Generate the map
			_this.map = new google.maps.Map(document.getElementById('vp-explore__map'), {
				zoom: _this.defaultZoom,
				draggable: true,
				scaleControl: false,
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false,
				gestureHandling: 'cooperative',
				zoomControl: true,
				maxZoom: _this.maxZoom,
				minZoom: _this.minZoom,
				center: { lat: _this.latitude, lng: _this.longitude }
			});

			styledMapType = new google.maps.StyledMapType( _this.mapStyle,
				[
					{
						"featureType": "administrative",
						"elementType": "labels.text.fill",
						"stylers": [
							{ "color": "#474747" }
						]
					},
					{
						"featureType": "administrative",
						"elementType": "labels.text.stroke",
						"stylers": [
							{ "weight": "0.01" }
						]
					},
					{
						"featureType": "administrative.province",
						"elementType": "geometry.stroke",
						"stylers": [
							{ "visibility": "off" }
					]
					},
					{
						"featureType": "landscape",
						"elementType": "geometry",
						"stylers": [
							{ "lightness": "0" },
							{ "saturation": "0" },
							{ "color": "#f4f4f4" },
							{ "gamma": "1" },
							{ "weight": "0.15" }
						]
					},
					{
						"featureType": "landscape.man_made",
						"elementType": "all",
						"stylers": [
							{ "lightness": "-3" },
							{ "gamma": "1.00" }
						]
					},
					{
						"featureType": "landscape.natural.terrain",
						"elementType": "all",
						"stylers": [
							{ "visibility": "off" }
						]
					},
					{
						"featureType": "poi",
						"elementType": "all",
						"stylers": [
							{ "visibility": "off" },
							{ "color": "#e84e38" }
						]
					},
					{
						"featureType": "poi",
						"elementType": "labels.text",
						"stylers": [
							{ "color": "#e84e38" }
						]
					},
					{
						"featureType": "poi",
						"elementType": "labels.text.stroke",
						"stylers": [
							{ "weight": "0.01" }
						]
					},
					{
						"featureType": "poi.park",
						"elementType": "geometry.fill",
						"stylers": [
							{ "color": "#bae5ce" },
							{ "visibility": "on" }
						]
					},
					{
						"featureType": "road",
						"elementType": "all",
						"stylers": [
							{ "saturation": -100 },
							{ "lightness": 45 },
							{ "visibility": "simplified" }
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "all",
						"stylers": [
							{ "visibility": "simplified" }
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "geometry.fill",
						"stylers": [
							{ "visibility": "simplified" },
							{ "color": "#f7cbc4" }
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "labels.text",
						"stylers": [
							{ "color": "#4e4e4e" }
						]
					},
					{
						"featureType": "road.arterial",
						"elementType": "labels.text.fill",
						"stylers": [
							{ "color": "#787878" }
						]
					},
					{
						"featureType": "road.arterial",
						"elementType": "labels.icon",
						"stylers": [
							{ "visibility": "off" }
						]
					},
					{
						"featureType": "transit",
						"elementType": "all",
						"stylers": [
							{ "visibility": "simplified" }
						]
					},
					{
						"featureType": "transit.station.airport",
						"elementType": "labels.icon",
						"stylers": [
							{ "hue": "#0a00ff" },
							{ "saturation": "-77" },
							{ "gamma": "0.57" },
							{ "lightness": "0" }
						]
					},
					{
						"featureType": "transit.station.rail",
						"elementType": "labels.text.fill",
						"stylers": [
							{ "color": "#43321e" }
						]
					},
					{
						"featureType": "transit.station.rail",
						"elementType": "labels.icon",
						"stylers": [
							{ "hue": "#ff6c00" },
							{ "lightness": "4" },
							{ "gamma": "0.75" },
							{ "saturation": "-68" }
						]
					},
					{
						"featureType": "water",
						"elementType": "all",
						"stylers": [
							{ "color": "#eaf6f8" },
							{ "visibility": "on" }
						]
					},
					{
						"featureType": "water",
						"elementType": "geometry.fill",
						"stylers": [
							{ "color": "#cde9f2" }
						]
					},
					{
						"featureType": "water",
						"elementType": "labels.text.fill",
						"stylers": [
							{ "lightness": "-49" },
							{ "saturation": "-53" },
							{ "gamma": "0.79" }
						]
					}
				],
				{name: 'Styled Map'});

			_this.map.mapTypes.set('styled_map', styledMapType);
			_this.map.setMapTypeId('styled_map');

			_this.geocoder = new google.maps.Geocoder();

			// Check if MarkerWithLabel is loaded then Generate Markers and Circles.
			// Getting script locally but included CDN url if we want to change it in the future
			// CDN: https://cdn.sobekrepository.org/includes/gmaps-markerwithlabel/1.9.1/gmaps-markerwithlabel-1.9.1.min.js
			if (typeof MarkerWithLabel !== 'object') {
				VP.helpers.loadScript('/wp-content/themes/visitphilly/dist/scripts/gmaps-markerwithlabel-1.9.1.min.js', function() {
					_this.drawMarkers();
					_this.drawLandmarks();
				});
			} else {
				_this.drawMarkers();
				_this.drawLandmarks();
			}

			// Fix for markers sometimes not appearing when zoom level is changed
			_this.zoomChange = google.maps.event.addListener(_this.map, 'zoom_changed', function() {
				_this.drawMarkers();
				_this.drawLandmarksDirection();

				setTimeout(function() {
					var cnt = _this.map.getCenter();
					cnt.e+=0.000001;
					_this.map.panTo(cnt);
					cnt.e-=0.000001;
					_this.map.panTo(cnt);
				}, 400);
			});

			// redraw landmark arrow on dragend and tileload
			google.maps.event.addListener(_this.map, 'dragend', function() {
				_this.drawLandmarksDirection();
				$('#vp-explore__reset-btn').fadeIn(200);
			});

			google.maps.event.addListener(_this.map, 'tilesloaded', function() {
				_this.drawLandmarksDirection();
				// override the google maps overlay setting to be over the neighborhood text
				// MTU, added only to .vp-explore__map, otherwise causes conflict with clickable events on area circles
				$('.vp-explore__map .gm-style-pbc').css( 'z-index', '50');
			});
		},

		shiftMapImage: function(dir, evt) {
			/*
			 * For mobile view. The buttons shift between the map view and picture of neigborhood
			 */
			var _this = this;
			if (dir === 'left') {
				_this.mapElement.addClass('vp-explore__map-shift-left');
				_this.neighborhoodImgContainerSmall.addClass('vp-explore__map-image-container-shift-left');
			} else {
				_this.mapElement.removeClass('vp-explore__map-shift-left');
				_this.neighborhoodImgContainerSmall.removeClass('vp-explore__map-image-container-shift-left');
			}

			$('.vp-area-arrow').removeClass('vp-area-arrow--inactive');

			if (evt) {
				$(evt.target).addClass('vp-area-arrow--inactive');
			}
		},

		// init swipeable events for detail view on mobile
		mobileDetailSwipeable: function() {
		    var _this = this;
		    var dragging = false;
		    var clickOnPageX = null;

		    // amount of pixel the user have to drag or swipe before the map slide over
		    var dragThreshold = 30;

		    $(document.body).on("touchmove mousemove", function(e) {
				// check if detail view is displayed
				var detailViewDisplay = _this.neighborhoodImgContainerSmall.hasClass('vp-explore__map-image-container--active');
		        if (dragging && detailViewDisplay === true) {
					var dragCoordinate = ( e.pageX ? e.pageX : e.originalEvent.touches[0].pageX );
		            var xPos = clickOnPageX - dragCoordinate;

		            if ( (dragCoordinate - dragThreshold) > clickOnPageX ) {
		                _this.shiftMapImage('right');
						$('.vp-area-arrow-prev').addClass('vp-area-arrow--inactive');
		            } else if ( (dragCoordinate + dragThreshold) < clickOnPageX ) {
		                _this.shiftMapImage('left');
						$('.vp-area-arrow-next').addClass('vp-area-arrow--inactive');
		            }
		        }
		    });

		    _this.mapContainerElement.on("touchstart mousedown", function (e) {
				if (VP.breakpoint.currentBreakpoint === 'small' && _this.swipeable === true) {
					dragging = true;
					//if it is desktop mouse event, use mouse coordinates else use touch cordinates
					clickOnPageX = ( e.pageX ? e.pageX : e.originalEvent.touches[0].pageX );
				}
		    });

			_this.neighborhoodImgContainerSmall.on("mousemove", function (e) {
				e.preventDefault();
			});

		    $(window).on("touchend mouseup", function (e) {
		        dragging = false;
		    });
		},

		gotoLandmark: function(e) {
			/*
			 * When clicking on an landmark list item,
			 * gets the coordinates from the landmark dataset
			 * the map pans to the Landmark pin
			 */
			var _this = this;

			for (var i = 0; i < _this.landmark_markers.length; i++) {
				_this.landmark_markers[i].setOptions({
					labelClass: 'vp-map-label-landmark',
					labelCurrent: false
				});
			}

			_this.landmark_legendItem.removeClass('vp-explore__landmarks-item--active');

			// if clicked landmark link is already active, then deactive it
			var isTargetActive = e.currentTarget.classList.contains('vp-explore__landmarks-item--active');

			if (isTargetActive) {
				e.currentTarget.classList.remove('vp-explore__landmarks-item--active');
				return;
			}

			e.currentTarget.classList.add('vp-explore__landmarks-item--active');

			var landmark = {
				name: e.currentTarget.getAttribute('data-landmark'),
				lat: "",
				lng: ""
			};

			_this.landmark_data.forEach(function (ele, index) {
				if (ele.name === landmark.name) {
					landmark.lat = parseFloat(ele.location.lat);
					landmark.lng = parseFloat(ele.location.lng);

					_this.landmark_markers[index].setOptions({
						labelClass: 'vp-map-label-landmark vp-map-label-landmark--active',
						labelCurrent: true
					});
				}
			});

			_this.map.panTo({
				lat: landmark.lat,
				lng: landmark.lng
			});

			_this.drawLandmarksDirection();
		},

		setRegionOptions: function() {
			/*
			 * Populates the Explore an Area select element from data
			 */
			var _this = this;

			_this.region_data.forEach(function(obj,i) {
				var newOption = document.createElement('option');
				var newOptionText = document.createTextNode(obj.region);
				newOption.appendChild(newOptionText);
				newOption.setAttribute('value', i);
				newOption.setAttribute('data-name', obj.region);
				_this.regionSelect.append(newOption);
			});
		},

		setNeighborhoodOptions: function() {
			/*
			 * Populates the Explore a Neighborhood when a new Region area is selected
			 */
			var _this = this;

			//create initial select option
			var initialOption = document.createElement('option');
			var initialOptionText = document.createTextNode('Select Neighborhood');
			initialOption.appendChild(initialOptionText);
			_this.neighborhoodSelect.append(initialOption);

			_this.areas.forEach(function(obj,i) {
				var newOption = document.createElement('option');
				var newOptionText = document.createTextNode(obj.name);
				newOption.appendChild(newOptionText);
				newOption.setAttribute('value', i);
				_this.neighborhoodSelect.append(newOption);
			});
		},

		setRegionSettings: function(regionName) {
			/*
			 * Sets all the region data after user selects a region
			 */
			var _this = this;

			var regionNum = 0;
			//find the region number from region name
			_this.region_data.forEach(function(obj,i) {
				if (obj.region === regionName) {
					_this.currentRegion = obj;
					regionNum = i;
					return;
				}
			});

			_this.areas = _this.region_data[regionNum].neighborhood;
			_this.defaultZoom = _this.region_data[regionNum].defaultZoom;
			_this.secondaryZoom = _this.region_data[regionNum].secondaryZoom;

			_this.regionSelect[0].selectedIndex = regionNum;

			if (_this.defaultZoom >= _this.secondaryZoom) {
				_this.maxZoom = _this.defaultZoom;
				_this.minZoom = _this.secondaryZoom;
			} else {
				_this.maxZoom = _this.secondaryZoom;
				_this.minZoom = _this.defaultZoom;
			}

			/*
			 * find the center point of the selected region
			 * used to center the map when a region is selected
			 */
			function getCenterPos(max, min) {
				var diff = (max - min) / 2;
				return max - diff;
			}

			function getRegionPos(region, subregion, minMax) {
				if (!subregion) {
					return region;
				} else {
					return Math[minMax](region, subregion);
				}
			}

			// get the boundaries of the neighborhoods
			var region_latMax = Math.max.apply(Math, _this.areas.map(function (obj) { return parseFloat(obj.location.lat); }));
			var region_latMin = Math.min.apply(Math, _this.areas.map(function (obj) { return parseFloat(obj.location.lat); }));
			var region_lngMax = Math.max.apply(Math, _this.areas.map(function (obj) { return parseFloat(obj.location.lng); }));
			var region_lngMin = Math.min.apply(Math, _this.areas.map(function (obj) { return parseFloat(obj.location.lng); }));

			var subregion_latMax = null;
			var subregion_latMin = null;
			var subregion_lngMax = null;
			var subregion_lngMin = null;

			// Check to see if the sub-regions parent region is the current selected region
			_this.region_data.forEach(function(subregion,i) {
				if (subregion.parentRegion === _this.currentRegion.region) {
					// get the boundary location of the sub-region nieghborhoods as well
					subregion_latMax = Math.max.apply(Math, subregion.neighborhood.map(function (obj) { return parseFloat(obj.location.lat); }));
					subregion_latMin = Math.min.apply(Math, subregion.neighborhood.map(function (obj) { return parseFloat(obj.location.lat); }));
					subregion_lngMax = Math.max.apply(Math, subregion.neighborhood.map(function (obj) { return parseFloat(obj.location.lng); }));
					subregion_lngMin = Math.min.apply(Math, subregion.neighborhood.map(function (obj) { return parseFloat(obj.location.lng); }));
				}
			});

			_this.latMax = getRegionPos(region_latMax, subregion_latMax, 'max');
			_this.latMin = getRegionPos(region_latMin, subregion_latMin, 'min');
			_this.lngMax = getRegionPos(region_lngMax, subregion_lngMax, 'max');
			_this.lngMin = getRegionPos(region_lngMin, subregion_lngMin, 'min');

			var latPos = getCenterPos(_this.latMax, _this.latMin);
			var lngPos = getCenterPos(_this.lngMax, _this.lngMin);

			_this.longitude = lngPos;
			_this.latitude = latPos;

			// populate neighborhood select options;
			// after emptying the Neighborhood select options
			_this.neighborhoodSelect.empty();

			_this.setNeighborhoodOptions();
		},

		resetRegion: function(regionName) {
			/*
			 * Closes neighborhood detail element
			 * Reset zoom level and redraw the markers
			 */
			var _this = this;
			_this.closeAreaDetail(false);

			_this.setRegionSettings(regionName);

			// set min and max zoom to largest possible to allow map to switch to new zoom level
			_this.map.setOptions({
				maxZoom: 20,
				minZoom: 0,
				center: { lat: _this.latitude, lng: _this.longitude }
			});

			_this.map.setZoom(_this.defaultZoom);

			// reset zoom level based on new region
			_this.map.setOptions({
				maxZoom: _this.maxZoom,
				minZoom: _this.minZoom
			});

			_this.drawMarkers();
			_this.reCenterMap();

			_this.mapOverlay.removeClass('vp-explore__map-overlay--hide');
			_this.neighborhoodImgContainerSmall.removeClass('vp-explore__map-image-container--active');
		},

		clearMarkers: function(map) {
			var _this = this;
			for (var i = 0; i < _this.markers.length; i++) {
				_this.markers[i].setMap(map);
	 			_this.circles[i].setMap(map);
			}
			_this.markers = [];
			_this.circles = [];
		},

		clearSubRegionMarkers: function(map) {
			var _this = this;
			if(_this.subregion_markers) {
				for (var i = 0; i < _this.subregion_markers.length; i++) {
				   _this.subregion_markers[i].setMap(map);
				   _this.subregion_circles[i].setMap(map);
				   _this.subregion_subCircles[i].setMap(map);
				}
			}
			_this.subregion_markers = [];
			_this.subregion_circles = [];
			_this.subregion_subCircles = [];
		},

		drawMarkers: function(region) {
			/*
			 * Draws the neighborhood labels and circle
			 */
			var _this = this;

			if (_this.canRedraw === false) {
				return;
			}

			if (_this.markers) {
				_this.clearMarkers(null);
			}

			var zoomLevel = _this.map.getZoom();

			$.each(_this.areas, function(i, area) {
				var currentLat = area.location.lat || 0;
				var currentLng = area.location.lng || 0;
				var currentRadius = area.rad || 200;

				var pos = new google.maps.LatLng(currentLat, currentLng);
				var labelClass = '';
				var labelZoomClass = '';

				// Check if its the left most location
				if( _this.leftMostLocation === null || parseFloat(currentLat) < _this.leftMostLocation.lng() ) {
					_this.leftMostLocation = pos;
				}

				if (zoomLevel <= 13) {
					labelZoomClass = "vp-map-label--zoomed-out";
				}

				/*
				 * Define map label class depending on area radius. This is to try to fit the text inside the red circles.
				 * Styling's file location: /wp-content/themes/visitphilly/assets/styles/objects/_maps.scss
				 */
				if(currentRadius <= 300) {
					labelClass = "vp-map-label--small";
				} else if(currentRadius <= 450) {
					labelClass = "vp-map-label--medium";
				} else {
					labelClass = "vp-map-label--large";
				}

				var marker = new MarkerWithLabel({
					map: _this.map,
					position: pos,
					labelContent: area.name,
					labelAnchor: new google.maps.Point(0, 0),
					labelClass: "vp-map-label " + labelClass + " " + labelZoomClass, // your desired CSS class
					labelInBackground: true,
					icon: ' ',
					clickable: false
				});

				// Add the same ID as the circle for relation.
				marker.set('id', i);
				_this.markers[i] = marker;

				// only add circles if it doesn't already exist
				if (!_this.circle) {
					// Add circle overlay and bind to marker
					var circle = new google.maps.Circle({
						map: _this.map,
						radius: area.rad,    // 10 miles in metres
						fillColor: '#E73F3F',
						strokeColor: 'transparent',
						center: pos,
						label: area.name,
						subregion: area.subregion
					});

					circle.set('position', pos);

					// Add the same ID as the marker for relation.
					circle.set('id', i);
					_this.circles[i] = circle;

					_this.addCircleHoverEffect(circle);
					_this.addCircleClickEvent(circle);
				}

				_this.processedLocations++;

				if(_this.processedLocations === _this.areas.length) {
					_this.reCenterMap();
					$(window).resize(function(e) {
						_this.reCenterMap();
					});
				}
			});

			_this.drawSubregionMarkers();
		},

		drawSubregionMarkers: function() {
			/*
			 * Draw markers for Subregions.
			 * Since subregions do not have location data, it will take the nieghborhood location data
			 */
			var _this = this;

			var sub_neighborhood = {};

			if (_this.subregion_markers) {
				_this.clearSubRegionMarkers(null);
			}

			var subregionTotal = 0;

			_this.region_data.forEach(function(region, i) {
				var subNeighborhoods_lat = [];
				var subNeighborhoods_lng = [];
				var subregionRadius = 614;


				if (region.is_subregion) {
					if (region.parentRegion === _this.currentRegion.region) {
						region.neighborhood.forEach(function(neighbor, j) {
							subNeighborhoods_lat.push(parseFloat(neighbor.location.lat));
							subNeighborhoods_lng.push(parseFloat(neighbor.location.lng));
						});

						// get subregion location by calculating average of neighborhood position
						var total_lat = 0;
						var total_lng = 0;
						var avg_lat = 0;
						var avg_lng = 0;

						for (var j = 0; j < subNeighborhoods_lat.length; j++) {
							total_lat += subNeighborhoods_lat[j];
							total_lng += subNeighborhoods_lng[j];
						}

						avg_lat = total_lat / subNeighborhoods_lat.length;
						avg_lng = total_lng / subNeighborhoods_lng.length;

						var subregion_pos = new google.maps.LatLng( avg_lat, avg_lng );

						var subregion_marker = new MarkerWithLabel({
							map: _this.map,
							position: subregion_pos,
							labelContent: region.region,
							labelAnchor: new google.maps.Point(0, 0),
							labelClass: "vp-map-label vp-map-label-subregion", // your desired CSS class
							labelInBackground: true,
							icon: ' '
						});

						// Add the same ID as the circle for relation.
						subregion_marker.set('id', subregionTotal);
						_this.subregion_markers[subregionTotal] = subregion_marker;

						// Sub region circles
						var subregion_circle = new google.maps.Circle({
							map: _this.map,
							radius: subregionRadius,
							fillColor: '#E73F3F',
							strokeColor: 'transparent',
							center: subregion_pos,
							label: region.region,
							subregion: region.region,
							labelClass: "vp-map-label-subregion-circle",
							fillOpacity: 0.22,
							outerCircle: true,
						});

						subregion_circle.set('position', subregion_pos);

						// Add the same ID as the circle for relation.
						subregion_circle.set('id', subregionTotal);
						_this.subregion_circles[subregionTotal] = subregion_circle;

						_this.addSubCircleHoverEffect(subregion_circle);
						_this.addSubCircleClickEvent(subregion_circle);

						// Second circle inside of the main circle for subregions
						var subregion_subCircle = new google.maps.Circle({
							map: _this.map,
							radius: subregionRadius * 0.78, // make it 78% size of the outer circle
							fillColor: '#E73F3F',
							strokeColor: 'transparent',
							center: subregion_pos,
							label: region.region,
							subregion: region.region,
							labelClass: "vp-map-label-subregion-circle-inner",
							fillOpacity: 0.3,
							innerCircle: true
						});

						subregion_subCircle.set('position', subregion_pos);

						// Add the same ID as the circle for relation.
						subregion_subCircle.set('id', subregionTotal);
						_this.subregion_subCircles[subregionTotal] = subregion_subCircle;

						_this.addSubCircleHoverEffect(subregion_subCircle, subregion_circle);
						_this.addSubCircleClickEvent(subregion_subCircle, subregion_circle);

						subregionTotal++;

					}
				}
			});
		},

		drawLandmarks: function() {
			/*
			 * Draw pins for all the landmarks on the map
			 */
			var _this = this;

			if (!_this.landmark_data.length) {
				// if there are no landmark data, hide the legend and indication bubble, exit function.
				$('.vp-explore__landmarks-direction-bubble').hide();
				$('.vp-explore__landmarks').hide();
				return;
			}

			_this.landmark_data.forEach(function(obj,i) {
				var pos = new google.maps.LatLng( obj.location.lat, obj.location.lng );

				var landmarker = new MarkerWithLabel({
					map: _this.map,
					position: pos,
					labelContent: i+1,
					labelName: obj.name,
					labelAnchor: new google.maps.Point(17, 43),
					labelClass: "vp-map-label-landmark",
					labelInBackground: false,
					labelVisible: true,
					labelCurrent: false,
					icon: ' ' //adding empty space will hide the default google marker
				});

				_this.landmark_markers.push(landmarker);
				_this.addLandmarksHoverEffect(landmarker);
			});

			_this.drawLandmarksDirection();

		},

		addLandmarksHoverEffect: function(marker, target) {
			/*
			 * Add hover effect for landmark pins
			 * Hovering over the pin also changes style for landmark list
			 */
			var _this = this;
			target = target || marker;

			var landmarkItems = $('.vp-explore__landmarks-item', _this.landmark_legend);
			var landmarkLinks = $('.vp-explore__landmarks-link', _this.landmark_legend);

			/*
			 *  Updates the legend styles when hovering over pin
			 */
			google.maps.event.addListener(marker, 'mouseover', function(e) {
				target.setOptions({
					labelClass: 'vp-map-label-landmark vp-map-label-landmark--active'
				});

				for (var i = 0; i < landmarkLinks.length; i++) {
					if (landmarkItems[i].getAttribute('data-landmark') === target.labelName) {
						landmarkItems[i].classList.add('vp-explore__landmarks-item--active');
					}
				}
			});

			google.maps.event.addListener(marker, 'mouseout', function(e) {
				if (!target.labelCurrent) {
					target.setOptions({
						labelClass: 'vp-map-label-landmark'
					});
				}

				landmarkItems.each(function(i, ele) {
					if (!_this.landmark_markers[i].labelCurrent) {
						ele.classList.remove('vp-explore__landmarks-item--active');
					}
				});
			});

			google.maps.event.addListener(marker, 'click', function(e) {
				_this.landmark_legendItem.removeClass('vp-explore__landmarks-item--active');
				_this.landmark_legendItem.removeClass('vp-explore__landmarks-item--current');

				_this.landmark_markers.forEach(function(marker, i) {
					marker.setOptions({
						labelClass: 'vp-map-label-landmark',
						labelCurrent: false
					});
				});

				target.setOptions({
					labelClass: 'vp-map-label-landmark vp-map-label-landmark--active',
					labelCurrent: true
				});

				for (var i = 0; i < landmarkLinks.length; i++) {
					landmarkItems[i].classList.remove('vp-explore__landmarks-item--active');
					if (landmarkItems[i].getAttribute('data-landmark') === target.labelName) {
						landmarkItems[i].classList.add('vp-explore__landmarks-item--active');
					}
				}
			});

			/*
			 *  Update the pin style when hovering over legend link
			 */
			 $('.vp-explore__landmarks-item').on('mouseover', function(e) {
				 var targetLandmark = e.currentTarget.getAttribute('data-landmark');
				 e.currentTarget.classList.add('vp-explore__landmarks-item--current');

				 _this.landmark_markers.forEach(function(landmark, i) {
					if (landmark.labelName === targetLandmark) {
						landmark.setOptions({
							labelClass: 'vp-map-label-landmark vp-map-label-landmark--active'
						});
					}
				 });
			 });

			 $('.vp-explore__landmarks-item').on('mouseout', function(e) {
				 e.currentTarget.classList.remove('vp-explore__landmarks-item--current');

				 _this.landmark_markers.forEach(function(landmark, i) {
					if (!landmark.labelCurrent) {
						landmark.setOptions({
	 						labelClass: 'vp-map-label-landmark'
	 					});
					}
				 });
			 });
		},

		drawLandmarksDirection: function() {
			/*
			 * Draw the arrow on the sides of the map
			 * The arrows point to landmarks that are off the map
			 */
			var _this = this;

			var currentMapBound = _this.map.getBounds();

			// check if map bounding number exist before drawing landmark direction arrows
			if (currentMapBound) {
				var boundPos = {
					north: currentMapBound.getNorthEast().lat(),
					east: currentMapBound.getNorthEast().lng(),
					south: currentMapBound.getSouthWest().lat(),
					west: currentMapBound.getSouthWest().lng()
				};

				var offmapDirection = ['north', 'east', 'south', 'west'];
				var directionOverlay = {
					north: [],
					east: [],
					south: [],
					west: []
				};

				_this.landmark_data.forEach(function(landmark, i) {

					var directionValue = {
						north: 0,
						east: 0,
						south: 0,
						west: 0
					};

					/*
					 * calculates the distance between the landmark and the boundary of the map
					 * determines which direction arrow will contain the off screen landmarks
					 */
					 var fLandmark_lat = parseFloat(landmark.location.lat);
					 var fLandmark_lng = parseFloat(landmark.location.lng);

					if ( fLandmark_lat > boundPos.north ) {
						directionValue.north = landmark.location.lat  - boundPos.north;
					} else if ( fLandmark_lat < boundPos.south ) {
						directionValue.south = boundPos.south - fLandmark_lat;
					}

					if ( fLandmark_lng > boundPos.east ) {
						directionValue.east = fLandmark_lng  - boundPos.east;
					} else if ( fLandmark_lng < boundPos.west ) {
						directionValue.west = boundPos.west - fLandmark_lng;
					}

					var arrDistance = Object.keys( directionValue ).map(function ( key ) { return directionValue[key]; });
					var furthestDistance = Math.max.apply('null', arrDistance);
					var furthestDistanceIndex = arrDistance.indexOf(Math.max.apply('null', arrDistance));
					if (furthestDistance > 0) {
						directionOverlay[offmapDirection[furthestDistanceIndex]].push(i + 1);
					}

					for (var key in directionOverlay) {
					    if (directionOverlay.hasOwnProperty(key)) {
							var contentEle = $('.vp-explore__landmarks-direction-bubble-text', _this.landmarkArrow[key]);
							contentEle.text(directionOverlay[key]);

							// hide the direction arrow if no landmars are in that direction
							if (!directionOverlay[key].length) {
								_this.landmarkArrow[key].addClass('vp-explore__landmarks-direction-bubble-hide');
							} else {
								_this.landmarkArrow[key].removeClass('vp-explore__landmarks-direction-bubble-hide');
							}
					    }
					}
				});
			}
		},

		reCenterMap: function() {
			var _this = this;
			var adjustedLng = 0;

			if (_this.canRedraw === false) { return; }

			if (VP.breakpoint.currentBreakpoint === 'large' || VP.breakpoint.currentBreakpoint === 'xlarge') {
				adjustedLng =  (_this.lngMax - _this.lngMin) / 3.33;
			}

			_this.map.panTo({
				lat: _this.latitude,
				lng: _this.longitude - adjustedLng
			});

			_this.drawLandmarksDirection();

			$('#vp-explore__reset-btn').fadeOut(200);
		},

		realignMap: function(retest, index) {
			var _this = this;
			var pos = null;
			var spacerDistance = null;
			retest = retest || false;
			var circleId = index;

			if( !retest ) {
				_this.resetBounds();
			}

			// Dont remove the spacer if this is a retest.
			if( !retest && _this.spacer !== null  ) {
				_this.spacer.setMap(null);
			}

			// If no neighborhood etail is showing.
			if( !_this.active ) {
				_this.map.set('draggable', true);

				_this.map.setOptions({
					maxZoom: _this.maxZoom
				});

				_this.map.setZoom(_this.defaultZoom);

				var zoomLevel = _this.map.getZoom();

				// NOTE: Spacer distance are only rough estimates
				// Spacers are used to offset the map to account for landmark list
				if( zoomLevel === 14 ) {
					spacerDistance = 0.025;
				} else if( zoomLevel === 13 ) {
					spacerDistance = 0.0650;
				} else if( zoomLevel <= 12 ) {
					spacerDistance = 0.32;
				}

				pos = new google.maps.LatLng(_this.leftMostLocation.lat(), _this.leftMostLocation.lng() - spacerDistance);

				// Spacer are hidden markers that will help center the map without overlapping the floating div (Landmarks).
				_this.spacer = new google.maps.Marker({
					map: _this.map,
					position: pos
				});

				_this.bounds.extend(pos);
				//_this.map.fitBounds(_this.bounds);
				_this.spacer.setVisible(false); // hide spacer

				// If the zoom level changed upon adding a spacer.
				if( zoomLevel !==  _this.map.getZoom() && !retest ) {
					_this.realignMap(true);
				}
			} else {
				pos = _this.active.position;

				_this.map.setOptions({
					maxZoom: _this.maxZoom + 1
				});

				_this.map.setZoom(_this.maxZoom + 1);

				_this.map.set('draggable', false);
				var bounds = new google.maps.LatLngBounds();

				var currentZoom = _this.map.getZoom();
				var defaultZoom = 12;
				var defaultSpacerDistance = 0.014;

				// Set different offset for different breakpoint.
				switch (VP.breakpoint.currentBreakpoint) {
					case 'small':
						defaultSpacerDistance = 0.02;
						break;
					case 'medium':
						defaultSpacerDistance = 0.065;
						break;
					case 'large':
						defaultSpacerDistance = 0.088;
						break;
					default:
						defaultSpacerDistance = 0.12;
						break;
				}

				var zoomNum = currentZoom - defaultZoom;
				spacerDistance = _this.getMapOffsetPos(defaultSpacerDistance, zoomNum);

				var spacerPos = new google.maps.LatLng(pos.lat(), pos.lng());
				bounds.extend(pos);
				bounds.extend(spacerPos);

				_this.spacer = new google.maps.Marker({
					map: _this.map,
					position: spacerPos
				});

				_this.map.fitBounds(bounds);

				// Add panTo for to center map on selected neighborhood in detail view.
				// fitbounds stopped working on reliably when selecting another neighborhood.
				_this.map.panTo({
					lat: pos.lat(),
					lng: pos.lng() + spacerDistance
				});

				_this.spacer.setVisible(false); // hide spacer
			}
		},

		/* calculate the offset position of the neigborhood circle for detail view
		 * @param: offestDistance - the default offset distance
		 * @param: zoom - the zoomLevel above or below the default zoom
		 */
		getMapOffsetPos: function (defaultSpacer, numDiff) {
			var sign = Math.sign(numDiff);
			var spacerNum = defaultSpacer;

			if (sign === 1) {
				for (i = 0; i < numDiff; i++) {
					spacerNum = spacerNum / 2;
				}
				return spacerNum;
			} else if (sign === 0) {
				return defaultSpacer;
			} else {
				for (i = 0; i < Math.abs(numDiff); i++) {
					spacerNum = spacerNum * 2;
				}
				return spacerNum;
			}
		},

		viewArea: function(obj) {
			var _this = this;
			// do not redraw markers when zooming to view neighborhood
			_this.canRedraw = false;

			// Hide all markers and circles
			_this.hideAreas();

			// Show only the selected area
			_this.markers[obj.id].setVisible(true);
			_this.circles[obj.id].setVisible(true);
			if( _this.subCircles[obj.id] ) {
				_this.subCircles[obj.id].setVisible(true);
			}

			// Add a class so we can increase the font size of the label.
			_this.markers[obj.id].labelClass = _this.markers[obj.id].labelClass + ' vp-map-label--active';

			_this.active = _this.markers[obj.id];

			_this.mapOverlay.addClass('vp-explore__map-overlay--hide');
			_this.neighborhoodImgContainerSmall.addClass('vp-explore__map-image-container--active');

			// Update map alignment
			_this.realignMap(false, obj.id);

			_this.showAreaDetail(obj.id);

			if (VP.breakpoint.currentBreakpoint !== 'small') {
				$("html, body").animate({ scrollTop: $(".vp-explore__map").offset().top - $(".vp-header").height() - 20 }, 200);
			}
		},

		hideAreas: function() {
			var _this = this;
			$.each(_this.markers, function(i, val) {
				_this.markers[i].setVisible(false);
				_this.circles[i].setVisible(false);

				if( _this.subCircles[i] ) {
					_this.subCircles[i].setVisible(false);
				}
			});

			$.each(_this.subregion_markers, function(i, val) {
				_this.subregion_markers[i].setVisible(false);
				_this.subregion_circles[i].setVisible(false);
				_this.subregion_subCircles[i].setVisible(false);
			});
		},

		showAreas: function() {
			/*
			 * Redraw the neighborhood markers.
			 */
			var _this = this;

			_this.realignMap(false);
			$.each(_this.markers, function(i, val) {
				_this.markers[i].setVisible(true);
				_this.circles[i].setVisible(true);

				if( _this.subCircles[i] ) {
					_this.subCircles[i].setVisible(true);
				}

				_this.markers[i].labelClass = _this.markers[i].labelClass.replace(" vp-map-label--active", "");
			});
		},

		showAreaDetail: function(index) {
			/*
			 * shows the neighborhood detail module
			 */
			var _this = this;
			_this.neighborhoodSelect[0].selectedIndex = index + 1;

			$('.vp-explore').addClass('vp-explore--active');
			$('#vp-explore__reset-btn').fadeOut(200);

			// hide arrow and remove swiping if there are no images.
			if (VP.breakpoint.currentBreakpoint === 'small') {
				_this.shiftMapImage('right');
				if (!_this.areas[index].imageResized) {
					$('.vp-area-arrow-container').hide();
					this.swipeable = false;
				} else {
					$('.vp-area-arrow-container').show();
					this.swipeable = true;
				}
			}

			setTimeout(function() {
				$('#vp-explore__area .vp-area__name').text(_this.areas[index].name);
				$('#vp-explore__area .vp-area__text').html(_this.areas[index].content);
				$('#vp-explore__area .vp-area__link').attr('href', _this.areas[index].link);
				$('.vp-explore__map-image-container .vp-area__link').attr('href', _this.areas[index].link);
				$('.vp-area__image img').attr({
					'src': _this.areas[index].imageResized,
					'alt': _this.areas[index].image.alt
				});
				$('.vp-explore__map-image-container img').attr({
					'src': _this.areas[index].imageResized,
					'alt': _this.areas[index].image.alt
				});
				$('#vp-explore__area').fadeIn(400);
			}, 300);
		},

		closeAreaDetail: function(centerNeighborhood) {
			/*
			 * Closes the neighborhood detail and reset back to the region view
			 * @param centerNeighborhood: Boolean - if true will re-center map on last selected neighborhood
			 */
 			var _this = this;
			$('.vp-explore').removeClass('vp-explore--active');
			$('#vp-explore__area').fadeOut(300, function() {
				$('.vp-area__image img').attr({
					'src': '',
					'alt': ''
				});
				$('.vp-explore__map-image-container img').attr({
					'src': '',
					'alt': ''
				});
				$('#vp-explore__reset-btn').fadeIn(200);
			});

			var currentNeighborIndex = _this.neighborhoodSelect[0].selectedIndex - 1;
			_this.neighborhoodSelect[0].selectedIndex = 0;

			_this.canRedraw = true;
			_this.active = false;

			_this.map.setOptions({
				maxZoom: _this.maxZoom
			});

			// Pan to center on last selected neighborhood
			// add delay to stop the map from blinking when zooming back out from detail view.
			if (centerNeighborhood) {
				setTimeout(function() {
					_this.map.panTo({
			           lat: parseFloat(_this.currentRegion.neighborhood[currentNeighborIndex].location.lat),
			            lng: parseFloat(_this.currentRegion.neighborhood[currentNeighborIndex].location.lng)
			        });
				}, 100);
			}

			_this.showAreas();
		},

		resetBounds: function() {
			var _this = this;
			_this.bounds = new google.maps.LatLngBounds();
			$.each(_this.markers, function(i, val) {
				_this.bounds.extend(val.position);
			});
		},

		addCircleHoverEffect: function(circle, target) {
			var _this = this;
			target = target || circle;

			google.maps.event.addListener(circle, 'mouseover', function(e) {
				// do not change opacity style if the map is in Detail View
				if ( !$('.vp-explore').hasClass('vp-explore--active') ) {
					target.setOptions({
						fillOpacity: 0.7
					});
				}

				_this.current_marker_label = _this.markers[target.id].labelClass;

				_this.markers[target.id].setOptions({
					labelClass: _this.current_marker_label + ' vp-map-label vp-map-label--hover'
				});
			});

			google.maps.event.addListener(circle, 'mouseout', function(e) {
				target.setOptions({
					fillOpacity: 0.3
				});

				_this.markers[target.id].setOptions({
					labelClass: _this.current_marker_label
				});
			});
		},

		addCircleClickEvent: function(circle, target) {
			/*
			 * Clicking on the circle show detail view on neighborhood
			 * unless it is a sub-region, then it will zoom into another neighborhood
			 */
			var _this = this;
			target = target || circle;

			google.maps.event.addListener(circle, 'click', function(e) {
				if (target.subregion) {
					_this.resetRegion(target.label);
				} else {
					_this.viewArea(target);
				}

				_this.markers[target.id].setOptions({
					labelClass: _this.current_marker_label
				});

				target.setOptions({
					fillOpacity: 0.3
				});
			});
		},

		addSubCircleHoverEffect: function(circle, target) {
			/*
			 * Styled specifically for sub-regions
			 */
			var _this = this;
			target = target || circle;

			google.maps.event.addListener(circle, 'mouseover', function(e) {
				_this.subregion_markers.forEach(function(marker, i) {
					if (marker.labelContent === circle.subregion) {
						_this.current_marker_label = marker.labelClass;
						marker.setOptions({
							labelClass: _this.current_marker_label + ' vp-map-label--hover'
						});

						_this.subregion_circles[i].setOptions({
							fillOpacity: 0.3
						});

						_this.subregion_subCircles[i].setOptions({
							fillOpacity: 0.6
						});
					}
				});
			});

			google.maps.event.addListener(circle, 'mouseout', function(e) {
				target.setOptions({
					fillOpacity: 0.3
				});

				_this.subregion_markers.forEach(function(marker, i) {
					marker.setOptions({
						labelClass: _this.current_marker_label
					});

					_this.subregion_circles[i].setOptions({
						fillOpacity: 0.22
					});

					_this.subregion_subCircles[i].setOptions({
						fillOpacity: 0.3
					});
				});
			});
		},

		addSubCircleClickEvent: function(circle, target) {
			var _this = this;
			target = target || circle;

			google.maps.event.addListener(circle, 'click', function(e) {
				if (target.subregion) {
					_this.resetRegion(target.label);
				} else {
					_this.viewArea(target);
				}

				_this.subregion_markers.forEach(function(marker, i) {
					marker.setOptions({
						labelClass: _this.current_marker_label
					});

					_this.subregion_circles[i].setOptions({
						fillOpacity: 0.22
					});

					_this.subregion_subCircles[i].setOptions({
						fillOpacity: 0.3
					});
				});
			});
		},
		bindEscClose: function () {
			// close detail view when user hits esc button
			var _this = this;
			$( document ).keyup( function( e ) {
				if ( e.which === 27 && _this.active ) {
					_this.closeAreaDetail(true);
				}
			});
		}
	};
})(jQuery);
